/* eslint-disable vue/max-len */

/** 语言 */
const lang = {
  $当前语言: '中文',
  中文: '中文',
  英文: '英文',
};

/** 菜单 */
const menu = {
  选款管理: '选款管理',
  AIGC选款列表: 'AIGC选款列表',
};

/** 表单 */
const form = {
  请选择: '请选择',
  请输入: '请输入',
  确定: '确定',
  确认: '确认',
  取消: '取消',
  提交: '提交',
  删除: '删除',
  警告: '警告',
  成功: '成功',
  失败: '失败',
  状态: '状态',
  提示: '提示',
  至: '至',
  只看我的: '只看我的',
  查询: '查询',
  重置: '重置',
  展开: '展开',
  收起: '收起',
  导入: '导入',
  导出: '导出',
  开始日期: '开始日期',
  结束日期: '结束日期',
  粘贴或拖放: '粘贴或拖放',
  文件上传: '文件上传',
  '请粘贴文件，或者把文件拖入输入框': '请粘贴文件，或者把文件拖入输入框',
  待上传文件: '待上传文件',
};

export default {
  ...lang,
  ...menu,
  ...form,
  品类: '品类',
  导入外部数据: '导入外部数据',
  批量标记: '批量标记',
  今日各版本未选任务款数: '今日各版本未选任务款数',
  选款人: '选款人',
  选款日期: '选款日期',
  灵感来源: '灵感来源',
  国家站点: '国家站点',
  跑图渠道: '跑图渠道',
  数据来源: '数据来源',
  选图人: '选图人',
  选图时间: '选图时间',
  全部: '全部',
  未选择: '未选择',
  可用: '可用',
  不可用: '不可用',
  版本: '版本',
  备注: '备注',
  选图记录: '选图记录',
  标记: '标记',
  全选: '全选',
  选择结果: '选择结果',
  请选择选图结果: '请选择选图结果',
  确认标记: '确认标记',
  建议价格: '建议价格',
  建议风格: '建议风格',
  建议类目: '建议类目',
  建议波段: '建议波段',
  建议店铺: '建议店铺',
  建议国家: '建议国家',
  建议印花: '建议印花',
  上传图片: '上传图片',
  新增店铺: '新增店铺',
  图: '图',
  请选择要标记的图片: '请选择要标记的图片',
  请填写完整要标记的图片信息: '请填写完整要标记的图片信息',
  标记成功: '标记成功',
  店铺名称: '店铺名称',
  店铺编码: '店铺编码',
  店铺名称不能为空: '店铺名称不能为空',
  店铺编码不能为空: '店铺编码不能为空',
  新增店铺成功: '新增店铺成功',
  提交成功: '提交成功',
  质检结果: '质检结果',
  请选择质检结果: '请选择质检结果',
  请选择图片以便定位问题: '请选择图片以便定位问题',
  已选: '已选',
  问题分类: '问题分类',
  请选择问题分类: '请选择问题分类',
  修图建议: '修图建议',
  通过: '通过',
  不通过: '不通过',
  SPU编码: 'SPU编码',
  数据: '数据',
  数量限制: '数量限制',
  格式限制: '格式限制',
  大小限制: '大小限制',
  详情: '详情',
  附件: '附件',
  选款结果: '选款结果',
  请上传文件: '请上传文件',
  导入数据: '导入数据',
  导入失败: '导入失败',
  '导入成功，部分导入失败': '导入成功，部分导入失败',
  导入成功: '导入成功',
  将文件拖到此处或: '将文件拖到此处或',
  点击上传: '点击上传',
  '严禁上传包含色情、暴力、反动等相关违法信息的文件。': '严禁上传包含色情、暴力、反动等相关违法信息的文件。',
  模板下载: '模板下载',
  导出结果: '导出结果',
  质检人: '质检人',
  质检日期: '质检日期',
  返修日期: '返修日期',
  QC结果: 'QC结果',
  图包上传人: '图包上传人',
  已返修: '已返修',
  未返修: '未返修',
  主图: '主图',
  问题图片: '问题图片',
  返修完成: '返修完成',
  操作: '操作',
  标记返修完成: '标记返修完成',
  '输入SPU搜索，可单个或者多个': '输入SPU搜索，可单个或者多个',
  '确定标记为已返修?': '确定标记为已返修?',
  名称: '名称',
};
